import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PaymentIcon from '@mui/icons-material/Payment';

const Footer = () => {
  const navigate = useNavigate();

  const features = [
    { icon: <LocalShippingIcon />, title: 'Free Shipping', desc: 'On orders above Rs.499' },
    { icon: <VerifiedUserIcon />, title: '100% Authentic', desc: 'Premium quality products' },
    { icon: <SupportAgentIcon />, title: '24/7 Support', desc: 'Dedicated customer service' },
    { icon: <PaymentIcon />, title: 'Secure Payment', desc: 'Multiple payment options' },
  ];

  return (
    <Box component="footer" sx={{ bgcolor: '#2C1810', color: '#fff', mt: 6 }}>
      {/* Features Bar */}
      <Box sx={{ bgcolor: '#3E2723', py: 3 }}>
        <Container maxWidth="lg">
          <Grid container spacing={2} justifyContent="center">
            {features.map((feature, index) => (
              <Grid item xs={6} sm={3} key={index}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, justifyContent: 'center' }}>
                  <Box sx={{ color: '#D2691E' }}>{feature.icon}</Box>
                  <Box>
                    <Typography variant="body2" fontWeight="bold">
                      {feature.title}
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#bbb' }}>
                      {feature.desc}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: 5 }}>
        <Grid container spacing={4}>
          {/* Brand Section */}
          <Grid item xs={12} md={4}>
            <Typography variant="h5" fontWeight="bold" sx={{ color: '#D2691E', mb: 2 }}>
              Nut Nutritions
            </Typography>
            <Typography variant="body2" sx={{ color: '#bbb', mb: 2, lineHeight: 1.8 }}>
              Your trusted source for premium quality dry fruits and nuts.
              We source the finest products from around the world to bring
              you natural goodness in every bite.
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <IconButton sx={{ color: '#fff', '&:hover': { color: '#D2691E' } }}>
                <FacebookIcon />
              </IconButton>
              <IconButton sx={{ color: '#fff', '&:hover': { color: '#D2691E' } }}>
                <InstagramIcon />
              </IconButton>
              <IconButton sx={{ color: '#fff', '&:hover': { color: '#D2691E' } }}>
                <TwitterIcon />
              </IconButton>
              <IconButton sx={{ color: '#fff', '&:hover': { color: '#D2691E' } }}>
                <YouTubeIcon />
              </IconButton>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={6} sm={3} md={2}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                component="button"
                onClick={() => navigate('/')}
                sx={{ color: '#bbb', textDecoration: 'none', textAlign: 'left', '&:hover': { color: '#D2691E' } }}
              >
                Home
              </Link>
              <Link
                component="button"
                onClick={() => navigate('/filter/All')}
                sx={{ color: '#bbb', textDecoration: 'none', textAlign: 'left', '&:hover': { color: '#D2691E' } }}
              >
                Shop All
              </Link>
              <Link
                component="button"
                onClick={() => navigate('/')}
                sx={{ color: '#bbb', textDecoration: 'none', textAlign: 'left', '&:hover': { color: '#D2691E' } }}
              >
                About Us
              </Link>
              <Link
                component="button"
                onClick={() => navigate('/contact')}
                sx={{ color: '#bbb', textDecoration: 'none', textAlign: 'left', '&:hover': { color: '#D2691E' } }}
              >
                Contact
              </Link>
            </Box>
          </Grid>

          {/* Categories */}
          <Grid item xs={6} sm={3} md={2}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
              Categories
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                component="button"
                onClick={() => navigate('/filter/Dry Fruits Premium')}
                sx={{ color: '#bbb', textDecoration: 'none', textAlign: 'left', '&:hover': { color: '#D2691E' } }}
              >
                Premium Dry Fruits
              </Link>
              <Link
                component="button"
                onClick={() => navigate('/filter/Dry Fruits Bulk')}
                sx={{ color: '#bbb', textDecoration: 'none', textAlign: 'left', '&:hover': { color: '#D2691E' } }}
              >
                Bulk Dry Fruits
              </Link>
              <Link
                component="button"
                onClick={() => navigate('/filter/Nuts')}
                sx={{ color: '#bbb', textDecoration: 'none', textAlign: 'left', '&:hover': { color: '#D2691E' } }}
              >
                Nuts & Seeds
              </Link>
              <Link
                component="button"
                onClick={() => navigate('/filter/Gift Boxes')}
                sx={{ color: '#bbb', textDecoration: 'none', textAlign: 'left', '&:hover': { color: '#D2691E' } }}
              >
                Gift Boxes
              </Link>
            </Box>
          </Grid>

          {/* Customer Service */}
          <Grid item xs={6} sm={3} md={2}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
              Customer Service
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                component="button"
                onClick={() => navigate('/orders')}
                sx={{ color: '#bbb', textDecoration: 'none', textAlign: 'left', '&:hover': { color: '#D2691E' } }}
              >
                Track Order
              </Link>
              <Link
                component="button"
                onClick={() => navigate('/faq')}
                sx={{ color: '#bbb', textDecoration: 'none', textAlign: 'left', '&:hover': { color: '#D2691E' } }}
              >
                FAQ
              </Link>
              <Link
                component="button"
                onClick={() => navigate('/shipping')}
                sx={{ color: '#bbb', textDecoration: 'none', textAlign: 'left', '&:hover': { color: '#D2691E' } }}
              >
                Shipping Policy
              </Link>
              <Link
                component="button"
                onClick={() => navigate('/returns')}
                sx={{ color: '#bbb', textDecoration: 'none', textAlign: 'left', '&:hover': { color: '#D2691E' } }}
              >
                Returns & Refunds
              </Link>
            </Box>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={6} sm={3} md={2}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
              Contact Us
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography variant="body2" sx={{ color: '#bbb' }}>
                Email: support@nutnutritions.com
              </Typography>
              <Typography variant="body2" sx={{ color: '#bbb' }}>
                Mon - Sat: 9AM - 7PM
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>

      <Divider sx={{ borderColor: '#3E2723' }} />

      {/* Copyright */}
      <Box sx={{ py: 2, textAlign: 'center' }}>
        <Typography variant="body2" sx={{ color: '#888' }}>
          © {new Date().getFullYear()} Nut Nutritions. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
